
import {dateFormat} from '~/plugins/formatting';

export default {
  name: 'BlogCardHeader',
  props: {
    article: {
      type: Object,
      required: true,
    },
    titleType: {
      type: String,
      default: 'div',
    },
    showAuthor: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    publishedAt() {
      return dateFormat(
        new Date(this.article.publishedAt),
        {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        },
        'ru-RU',
      );
    },
  },
}
